import React, { useRef } from 'react';
import t from 'prop-types';
import { Tooltip as ControlledTooltip, UncontrolledTooltip } from 'reactstrap';
import { Icon } from './Icon';

export const Tooltip = ({ children, content, disabled, href, ...props }) => {
  const ref = useRef(null);
  // If isOpen prop is provided, use a controlled tooltip
  const Component =
    typeof props.isOpen === 'undefined'
      ? UncontrolledTooltip
      : ControlledTooltip;

  // Determine if the tooltip is a link or not
  const isLinked = !!href;

  return disabled ? (
    children({ ref })
  ) : (
    <>
      {children({ ref })}
      <Component
        target={ref}
        {...(isLinked
          ? { delay: { show: 1000 }, placement: 'right', autohide: false }
          : {})}
        {...props}
      >
        {isLinked ? (
          <a href={href} target="_blank" rel="noreferrer">
            {content || (
              <>
                <Icon name="help-circle" md />
                <span>Learn more</span>
                <Icon name="arrow-right" md />
              </>
            )}
          </a>
        ) : (
          content
        )}
      </Component>
    </>
  );
};

Tooltip.propTypes = {
  /**
   * Render function that is passed an object with a `ref` property. This
   * function should render an element which gets passed the `ref` to trigger
   * the tooltip.
   */
  children: t.func.isRequired,
  /** Content to display in the tooltip. */
  content: t.node,
  /**
   * If true, the Tooltip component won't be rendered, and only the children
   * render function will be rendered.
   */
  disabled: t.bool,
  /**
   * Should the tooltip be a link. If a value is provided, the tooltip will
   * have the following default properties applied: `Learn more` label with
   * icons as the content, 1 second show delay, right placement, and autohide
   * set to false.
   */
  href: t.string,
};
